/**
 * Cookie
 */

$(document).ready(function () {
    $('.cookie-message').cookieBar({closeButton: '#cookie-banner'});
});

/**
 * Scroll down
 */
// Seleziona l'elemento della freccia
const scrollChevron = document.getElementById('chevron');

// Verifica che l'elemento esista
if (scrollChevron) {

// Aggiungi il comportamento al click sulla freccia
    scrollChevron.addEventListener('click', () => {
        // Scroll verso il basso di una schermata
        window.scrollTo({
            top: window.innerHeight, // Posizione verticale
            behavior: 'smooth' // Scroll fluido
        });

        // Nasconde la freccia
        scrollChevron.classList.add('hidden');
    });

// Mostra/nasconde la freccia quando l'utente fa scroll
    window.addEventListener('scroll', () => {
        // Mostra la freccia se l'utente è vicino alla cima della pagina
        if (window.scrollY < 50) {
            scrollChevron.classList.remove('hidden');
        }
        // Altrimenti, la freccia resta nascosta
        else {
            scrollChevron.classList.add('hidden');
        }
    });
}

/**
 Hamburgers
 */

// Evento sul pulsante hamburger
document.getElementById("btn-hamburger").addEventListener("click", function () {
    // Alterna la classe 'reveal' sull'elemento con classe 'bg-cover'
    document.querySelector('.bg-cover').classList.toggle('reveal');

    // Alterna la classe 'is-active' sull'elemento stesso
    this.classList.toggle("is-active");

    // Alterna la classe 'open' sull'elemento con ID 'header-collapse'
    const headerCollapse = document.getElementById("header-collapse");
    headerCollapse.classList.toggle("open");

    // Nascondi o mostra il div con classe "quote"
    const quote = document.querySelector('.quote');
    if (headerCollapse.classList.contains("open")) {
        quote.style.opacity = "0"; // Forza il div a scomparire
        quote.style.visibility = "hidden"; // Rimuovi la visibilità
        quote.style.pointerEvents = "none"; // Disabilita interazione
    } else {
        quote.style.opacity = "1"; // Ripristina il div
        quote.style.visibility = "visible"; // Rende visibile l'elemento
        quote.style.pointerEvents = "auto"; // Ripristina interazione
    }
});

// Evento sullo sfondo con classe 'bg-cover'
document.querySelector('.bg-cover').addEventListener("click", function () {
    // Alterna la classe 'reveal' sull'elemento con classe 'bg-cover'
    document.querySelector('.bg-cover').classList.toggle('reveal');

    // Alterna la classe 'is-active' sul pulsante hamburger
    document.getElementById("btn-hamburger").classList.toggle("is-active");

    // Alterna la classe 'open' sull'elemento con ID 'header-collapse'
    const headerCollapse = document.getElementById("header-collapse");
    headerCollapse.classList.toggle("open");

    // Nascondi o mostra il div con classe "quote"
    const quote = document.querySelector('.quote');
    if (headerCollapse.classList.contains("open")) {
        quote.style.opacity = "0"; // Forza il div a scomparire
        quote.style.visibility = "hidden"; // Rimuovi la visibilità
        quote.style.pointerEvents = "none"; // Disabilita interazione
    } else {
        quote.style.opacity = "1"; // Ripristina il div
        quote.style.visibility = "visible"; // Rende visibile l'elemento
        quote.style.pointerEvents = "auto"; // Ripristina interazione
    }
});

// $("#btn-hamburger").on("click", function () {
//
//     // $("#btn-hamburger-sticky").toggleClass("is-active");
//
//     $('.bg-cover').toggleClass('reveal');
//
//     $(this).toggleClass("is-active");
//
//     $("#header-collapse").toggleClass("open");
// });
//
// $('.bg-cover').on("click", function(){
//     $('.bg-cover').toggleClass('reveal');
//     // $("#btn-hamburger-sticky").toggleClass("is-active");
//     $("#btn-hamburger").toggleClass("is-active");
//     $("#header-collapse").toggleClass("open");
// })

$('#header-collapse').on("click", function (event) {
    event.stopPropagation();
});

/**
 * Sticky Header
 */

$(document).ready(function () {
    $(window).trigger('scroll');
    $(window).bind('scroll', function () {
        let pixels = 200; //number of pixels before modifying styles
        if ($(window).scrollTop() > pixels) {

            $("#header").addClass('sticky').css({"background-color": "rgba(255, 255, 255, .9)", "position": "fixed"});

            $("#logo").removeClass('logo').addClass('logo-sticky');

            $("#btn-contact").removeClass('btn-contact').addClass('btn-contact-sticky');

            $("#hamburger").addClass("btn-hamburger-sticky");

        } else {

            $("#header").removeClass('sticky').removeAttr("style");

            $("#hamburger").removeClass("btn-hamburger-sticky");

            $("#logo").removeClass('logo-sticky').addClass('logo');

            $("#btn-contact").removeClass('btn-contact-sticky').addClass('btn-contact');
        }
    });
});

/**
 * Dropdown menu
 */

// $(document).ready(function() {
//
//     // $('#xl ul.nav li.dropdown').hover(function() {
//     //     $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
//     // }, function() {
//     //     $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
//     // });
//     // $('#xl ul.nav li.dropdown').hover(function(e) {
//     //     e.stopPropagation()
//     // });
//
//     $('#xl li.dropdown').hover(function() {
//         $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(100);
//         // $(this).css("background-color", "yellow");
//         $(this).addClass('marker');
//         // function(){$(this).removeClass('hover')}
//     }, function() {
//         $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(100);
//         $(this).removeClass('marker');
//     });
// });

/**
 * Scroll
 */

$(document).ready(function () {

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('.scrollup').fadeIn();
        } else {
            $('.scrollup').fadeOut();
        }
    });

    $('.scrollup').click(function () {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });

});

/**
 * Submit user
 */

document.addEventListener("DOMContentLoaded", function () {

    // Imposta il maxlength per il campo message
    const messageTextarea = document.querySelector('textarea[name$="message"]');
    if (messageTextarea) {
        messageTextarea.setAttribute('maxlength', '250');
    }

    // Converte il valore delle email in lettere minuscole durante l'input
    const emailInput = document.querySelector('input[name$="email"]');
    if (emailInput) {
        emailInput.addEventListener('keyup', function () {
            this.value = this.value.toLowerCase();
        });
    }

    const emailConfirmationInput = document.querySelector('input[name$="email_c"]');
    if (emailConfirmationInput) {
        emailConfirmationInput.addEventListener('keyup', function () {
            this.value = this.value.toLowerCase();
        });
    }

    // Permette solo numeri, trattini e il simbolo "+"
    const phoneInput = document.querySelector('input[name$="phone"]');
    if (phoneInput) {
        phoneInput.setAttribute('maxlength', '16');
        phoneInput.addEventListener('input', function () {
            this.value = this.value.replace(/[^0-9-+]/g, '');
        });
    }

    // Limita il numero massimo di caratteri per il campo travelers e permette solo numeri
    const travelersInput = document.querySelector('input[name$="travelers"]');
    if (travelersInput) {
        travelersInput.setAttribute('maxlength', '3');
        travelersInput.addEventListener('input', function () {
            this.value = this.value.replace(/[^0-9]/g, '');
        });
    }

    // Consente solo numeri e trattini per il campo date_start
    const dateStartInput = document.querySelector('input[name$="date_start"]');
    if (dateStartInput) {
        dateStartInput.setAttribute('maxlength', '10');
        dateStartInput.addEventListener('input', function () {
            this.value = this.value.replace(/[^0-9-]/g, '');
        });
    }

    // Limita il numero massimo di caratteri per il campo days e permette solo numeri
    const daysInput = document.querySelector('input[name$="days"]');
    if (daysInput) {
        daysInput.setAttribute('maxlength', '3');
        daysInput.addEventListener('input', function () {
            this.value = this.value.replace(/[^0-9]/g, '');
        });
    }

    // Seleziona l'elemento del campo data
    const elem = document.querySelector('input[name="date_start"]');

    if (elem) {
        // Ottieni la data corrente formattata come 'yyyy-mm-dd'
        const today = new Date();
        const formattedToday = today.toISOString().split('T')[0];

        // Controlla che il div contenente il linguaggio esista
        const languageDiv = document.querySelector('.twig-js-var');
        if (languageDiv) {
            const language = languageDiv.getAttribute('data-language') || 'en'; // Default 'en' se data-language è assente

            // Inizializza il datepicker
            const datepicker = new Datepicker(elem, {
                language: language,
                clearBtn: true,
                format: 'yyyy-mm-dd',
                // Restrizione: consenti solo date dal giorno corrente in avanti
                minDate: formattedToday,
            });
        } else {
            console.warn('Elemento .twig-js-var non trovato. Il datepicker non può essere inizializzato correttamente.');
        }
    } else {
        console.warn('Elemento input[name="date_start"] non trovato. Il datepicker non è stato inizializzato.');
    }

    // Estrai reCaptcha site key dal div twig-js-var
    const recaptchaSiteKey = document.querySelector('.twig-js-var').getAttribute('data-recaptcha_site_key');

    $(function () {
        const form = '#form_contact';
        const form_message = form + '-message';

        // Disabilita il pulsante di invio
        var disableSubmit = function (val) {
            $(form + ' input[type=submit]').attr('disabled', val);
        };

        /**
         * Validazione del modulo lato client
         * Controlla che i campi obbligatori siano compilati e validi
         */
        const validateForm = () => {
            let isValid = true; // Stato inizialmente valido

            // Campi obbligatori da verificare
            const requiredFields = [
                {name: 'firstname', message: 'First name is required.'},
                {name: 'lastname', message: 'Last name is required.'},
                {name: 'email', message: 'A valid email is required.'},
                {name: 'phone', message: 'A valid phone number is required.', isPhone: true},
                {name: 'travelers', message: 'Number of travelers is required.', isNumber: true},
                {name: 'days', message: 'Number of days is required.', isNumber: true},
                {name: 'date_start', message: 'A valid departure date is required.', isDate: true},
                {name: 'privacy', message: 'You must accept the privacy policy.', type: 'checkbox'},
                {name: 'budget', message: 'Please select a budget.', isSelect: true},
                {name: 'message', message: 'Message is required and must not exceed 250 characters.', isTextarea: true}
            ];

            // Loop attraverso ogni campo obbligatorio
            requiredFields.forEach((field) => {
                const fieldElem = document.querySelector(`#form_contact [name="${field.name}"]`);

                if (fieldElem) {
                    // Validazione per i campi di tipo `textarea`
                    if (field.isTextarea) {
                        if (fieldElem.value.trim() === '' || fieldElem.value.length > 250) {
                            isValid = false;
                            showFieldError(fieldElem, field.message); // Mostra errore per il campo `message`
                        } else {
                            removeFieldError(fieldElem); // Rimuove l'errore se valido
                        }
                    }
                    // Condizione per campi select
                    else if (field.isSelect) {
                        if (fieldElem.value === '0') { // Considera 0 come valore non valido
                            isValid = false;
                            showFieldError(fieldElem, field.message); // Mostra errore per il campo budget
                        } else {
                            removeFieldError(fieldElem); // Rimuove eventuali errori se validi
                        }
                    }
                    // Condizione per checkbox
                    else if (field.type === 'checkbox') {
                        if (!fieldElem.checked) {
                            isValid = false;
                            showFieldError(fieldElem, field.message); // Mostra errore per checkbox
                        } else {
                            removeFieldError(fieldElem); // Rimuove eventuali errori se valido
                        }
                    }
                    // Validazione specifica per determinati tipi di campo
                    else if (field.isPhone) {
                        if (!isValidPhone(fieldElem.value)) {
                            isValid = false;
                            showFieldError(fieldElem, field.message); // Telefono non valido
                        } else {
                            removeFieldError(fieldElem);
                        }
                    } else if (field.isNumber) {
                        if (!isValidNumber(fieldElem.value)) {
                            isValid = false;
                            showFieldError(fieldElem, field.message); // Numero non valido
                        } else {
                            removeFieldError(fieldElem);
                        }
                    } else if (field.isDate) {
                        if (!isValidDate(fieldElem.value)) {
                            isValid = false;
                            showFieldError(fieldElem, field.message); // Data non valida
                        } else {
                            removeFieldError(fieldElem);
                        }
                    }
                    // Condizione per campi di testo generici come email
                    else {
                        if (fieldElem.value.trim() === '' || (field.name === 'email' && !isValidEmail(fieldElem.value))) {
                            isValid = false;
                            showFieldError(fieldElem, field.message); // Mostra errore per campi input
                        } else {
                            removeFieldError(fieldElem);
                        }
                    }
                }
            });

            return isValid; // Restituisce lo stato della validazione
        };

        /**
         * Funzione per verificare se una stringa è un'email valida
         */
        const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        /**
         * Funzione per verificare se un valore è un numero valido
         */
        const isValidNumber = (number) => /^[1-9][0-9]*$/.test(number);

        /**
         * Funzione per verificare se un valore è un numero di telefono valido
         */
        const isValidPhone = (phone) => /^[0-9()+\-\s]+$/.test(phone.trim());

        /**
         * Funzione per verificare se una data è valida
         */
        const isValidDate = (date) => !isNaN(Date.parse(date));

        const showFieldError = (field, message) => {
            field.classList.add('is-invalid');
            let errorElem = field.parentNode.querySelector('.error-message');
            if (errorElem) errorElem.remove();

            errorElem = document.createElement('div');
            errorElem.className = 'error-message text-danger mt-1';
            errorElem.textContent = message;
            field.parentNode.appendChild(errorElem);
        };

        const removeFieldError = (field) => {
            field.classList.remove('is-invalid');
            const errorElem = field.parentNode.querySelector('.error-message');
            if (errorElem) errorElem.remove();
        };

        // Event handler per il submit del form
        $(form).on('submit', function (e) {
            e.preventDefault();

            const msg = '#error_contact';

            if (!validateForm()) {
                $(form_message).removeClass().addClass('alert alert-danger').html('Please correct the highlighted fields.');
                return;
            }

            grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaSiteKey, {action: 'submit'}).then(function (token) {
                    var recaptchaResponse = document.getElementById('recaptchaResponse');
                    recaptchaResponse.value = token;

                    $.ajax({
                        type: 'post',
                        dataType: 'json',
                        data: $(form).serialize(),
                        beforeSend: function () {
                            $(form_message).removeClass().addClass('loading').html('Loading...');
                        },
                        success: function (json) {
                            if (json.stato === 1) {
                                $(form).trigger('reset');
                                $('#user').modal('show');
                                $(msg).removeClass().addClass(json.type).html(json.message).fadeIn('slow');
                                setTimeout(function () {
                                    $('#user').modal('hide');
                                    if (json.redirect) {
                                        // Effettua il redirect a una pagina di ringraziamento
                                        window.location.href = json.redirect; // Sostituisci con l'URL della pagina desiderata
                                    }
                                }, 5000); // Aspetta 5 secondi prima del redirect
                                $(form).hide();
                                $('#abstract').hide();
                                $('#thankyou').show('slow');
                            } else {
                                $('#user').modal('show');
                                $(msg).removeClass().addClass(json.type).html(json.message).fadeIn('slow');
                                setTimeout(function () {
                                    $('#user').modal('hide');
                                }, 5000);
                            }
                            // if (json.stato === 1) {
                            //     $(form).trigger('reset');
                            //     $(form_message).removeClass().addClass('alert alert-success').html(json.message);
                            // } else {
                            //     $(form_message).removeClass().addClass('alert alert-danger').html(json.message);
                            // }
                        },
                        error: function () {
                            $(form_message).removeClass().addClass('alert alert-danger').html('An error occurred.');
                        }
                    });
                });
            });
        });
    });
});

// /Submit user

/*
 * Light case
 */

// jQuery(document).ready(function($) {
//     $('a[data-rel^=lightcase]').lightcase({
//         showSequenceInfo: false,
//         showTitle: false
//     });
// });

/*
 * GLightbox
 */

const lightbox = GLightbox({
    selector: '.glightgallery',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
    onOpen: () => {
        console.log('Lightbox opened')
    },
    beforeSlideLoad: (slide, data) => {
        // Need to execute a script in the slide?
        // You can do that here...
    }
});
const lightboxVideo = GLightbox({
    selector: '.glightboxvideo',
});

/*
 * Lozad
 */

// const observer = lozad(); // lazy loads elements with default selector as '.lozad'
// observer.observe();

/**
 * Swiper
 */

jQuery(function () {
    jQuery('#showall').click(function () {
        jQuery('.targetDiv').show();
    });
    jQuery('.app-year-inner').click(function () {
        jQuery('.targetDiv').hide();
        jQuery('#div' + $(this).attr('target')).show();
    });
});

(function ($) {
    "use strict";

    $(function () {
        // if (!$("html").hasClass("app-ourhistory-page")) return;

        init();

        $(window).on('resize', function () {
            init();
        });
    })

    let inited = false;
    let desktop_inited = false;

    function init() {

        if (!inited) {
            inited = true;
            initAccordion();
        }

        // desktop specific
        let is_desktop = true;

        // let is_desktop = window.matchMedia("(min-width: 240px)").matches; // 1024
        if (is_desktop && !desktop_inited) {
            desktop_inited = true;
            initDesktopNavigator();
        }

    }

    function initAccordion() {

        let container = $(".app-contents");
        let anchors = container.find(".app-mob-picker a");


        anchors.click(function (e) {

            e.preventDefault();
            e.stopPropagation();

            let $this = $(this),
                li = $this.closest(".app-mob-picker");

            // change baloon style
            anchors.each(function () {
                $(this).closest(".app-mob-picker").removeClass("app-selected");
            });
            li.addClass("app-selected");

            // show contents
            showYearContents(li.data("year"));

            // scroll contents up
            $('html, body').animate({
                scrollTop: (li.offset().top - 40)
            }, 400);

        })

    }

    function initDesktopNavigator() {

        let nav = $(".app-navigator"),
            slides = nav.find(".app-year");

        // Controlla se l'elemento Swiper esiste
        if ($('.app-navigator-inner .swiper').length === 0) {
            console.warn("Swiper non inizializzato: elemento non trovato nella pagina");
            return; // Interrompe l'esecuzione della funzione
        }

        // init scroller
        const swiper = new Swiper('.app-navigator-inner .swiper', {

            slidesPerView: 9,
            spaceBetween: 68,
            // centeredSlides: true,

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
                1024: {
                    slidesPerView: 8,
                    spaceBetween: 63,
                },
            },
        });

        let slide = slides.first().find("a").closest(".app-year");
        // let slide = slides.last().find("a").closest(".app-year");
        slides.removeClass("app-active");
        slide.addClass("app-active");

        // move scroller
        let index = slides.index(slide);
        swiper.slideTo(index, 400, false);

        // handle slide change
        slides.on("click", "a", function (e) {
            e.preventDefault();

            // change button style
            let slide = $(this).closest(".app-year");
            slides.removeClass("app-active");
            slide.addClass("app-active");

            // move scroller
            let index = slides.index(slide);
            swiper.slideTo(index, 400, false);

            // show contents
            // let url = $(this).attr("href");
            // window.location = url;

            // showYearContents(slide.data("year"));

        });

        // preselect last slide
        // slides.last().find("a").click();

    }

    function showYearContents(year) {

        let years = $(".app-year-cont");

        years.removeClass("app-active");

        let selected = years.filter(function () {
            return $(this).data("year") === year;
        })

        selected.addClass("app-active");

    }

})(jQuery);

const swiper = new Swiper('.wrapper-swiper .container .swiper', {
    preloadImages: false,
    // Enable lazy loading
    lazy: true,
    effect: "fade",
    speed: 1000,
    loop: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    mousewheel: false,
    keyboard: true,
});

const swiper_xs = new Swiper('.wrapper-swiper-xs .container .swiper', {
    preloadImages: false,
    // Enable lazy loading
    lazy: true,
    effect: "fade",
    speed: 1000,
    loop: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    mousewheel: false,
    keyboard: true,
});

// Slide visibili per breakpoint nello swiper servizi/esperienze
const servicesExperiencesPerView = {
    320: 1,
    480: 1,
    768: 1,
    1024: 2,
    1280: 3,
    1440: 3,
    1920: 4,
    2560: 4,
};

document.querySelectorAll('.wrapper-swiper-services-experiences .container-fluid .swiper').forEach(function (el) {
    const slidesCount = el.querySelectorAll('.swiper-slide').length;
    const breakpoints = {};

    // Il loop richiede più slide di quelle visibili: se non bastano lo disattiviamo per quel breakpoint
    Object.keys(servicesExperiencesPerView).forEach(function (bp) {
        const perView = servicesExperiencesPerView[bp];
        breakpoints[bp] = {
            slidesPerView: perView,
            spaceBetween: 0,
            loop: slidesCount > perView,
        };
    });

    new Swiper(el, {
        preloadImages: false,
        lazy: true,
        slidesPerView: 1,
        loop: slidesCount > 1,
        centerInsufficientSlides: true, // Centra le slide se non riempiono la riga
        watchOverflow: true, // Nasconde le frecce (swiper-button-lock) se tutte le slide sono visibili
        navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        mousewheel: false,
        keyboard: {
            enabled: true,
        },
        breakpoints: breakpoints,
    });
});


/**
 *
 */

// var lazyLoadInstance = new LazyLoad({
//     // Your custom settings go here
// });

/**
 * Mobile Version Video
 */

// let isMobileVersion = document.getElementsByClassName("bgkvideo-xs");
// if (isMobileVersion.length > 0) {
//     isMobileVersion[0].setAttribute("playsinline", "");
//     isMobileVersion[0].setAttribute("muted", "");
// }
//
// var mobilevideo = document.getElementsByClassName("bgkvideo-xs")[0];
// mobilevideo.setAttribute("playsinline", "");
// mobilevideo.setAttribute("muted", "");

/**
 * Detect Mobile device
 */
let isMobile = false; //initiate as false
// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    isMobile = true;
}


/**
 * Load more button for services and experience
 */

document.addEventListener("DOMContentLoaded", function () {
    // Controlla se il pulsante esiste per evitare errori
    const loadMoreButton = document.getElementById("load-more");
    if (!loadMoreButton) {
        return; // Esci dallo script se il bottone non è presente
    }

    const hiddenBlocks = document.querySelectorAll(".hidden-block");
    const step = 6; // Numero di blocchi da mostrare per ogni clic
    let currentIndex = 0;

    // Mostra o nascondi il pulsante "Load More" al caricamento della pagina
    if (hiddenBlocks.length > 0) {
        loadMoreButton.parentElement.style.display = "block";
    } else {
        loadMoreButton.parentElement.style.display = "none";
    }

    loadMoreButton.addEventListener("click", function () {
        for (let i = currentIndex; i < currentIndex + step && i < hiddenBlocks.length; i++) {
            hiddenBlocks[i].classList.remove("hidden-block"); // Rimuove la classe "hidden-block"
        }

        currentIndex += step;

        // Nasconde il bottone se non ci sono più blocchi da mostrare
        if (currentIndex >= hiddenBlocks.length) {
            loadMoreButton.parentElement.style.display = "none";
        }
    });
});

/**
 * Read more
 */

// let noOfCharac = 300;
// let contents = document.querySelectorAll(".abstract");
// contents.forEach(content => {
//     //If text length is less that noOfCharac... then hide the read more button
//     if(content.textContent.length < noOfCharac){
//         content.nextElementSibling.style.display = "none";
//     }
//     else{
//         let displayText = content.textContent.slice(0,noOfCharac);
//         let moreText = content.textContent.slice(noOfCharac);
//         content.innerHTML = `${displayText}<span class="dots">...</span><span class="hide more">${moreText}</span>`;
//     }
// });

// function readMore(btn){
//     let post = btn.parentElement;
//     post.querySelector(".dots").classList.toggle("hide");
//     post.querySelector(".more").classList.toggle("hide");
//     btn.textContent == "Read More" ? btn.textContent = "Read Less" : btn.textContent = "Read More";
// }
//
// document.getElementsByClassName("btnHideShow").addEventListener("click", readMore);

$('.cnt').hide();

jQuery(function () {
    // jQuery('#showall').click(function(){
    //     jQuery('.targetDiv').show();
    // });

    jQuery('.showSingle').click(function () {
        jQuery('.targetDiv').hide();

        jQuery('.cnt').show();
        jQuery('#div' + $(this).attr('target')).show();

    });
});

jQuery(function ($) {
    function AddReadMore() {
        //This limit you can set after how much characters you want to show Read More.
        var carLmt = 300;
        // Text to show when text is collapsed
        var readMoreTxt = " ...read more";
        // Text to show when text is expanded
        var readLessTxt = " read less";


        //Traverse all selectors with this class and manipulate HTML part to show Read More
        $(".add-read-more").each(function () {
            if ($(this).find(".first-section").length)
                return;

            var allstr = $(this).text();
            if (allstr.length > carLmt) {
                var firstSet = allstr.substring(0, carLmt);
                var secdHalf = allstr.substring(carLmt, allstr.length);
                var strtoadd = firstSet + "<span class='second-section'>" + secdHalf + "</span><span class='read-more'  title='Click to Show More'>" + readMoreTxt + "</span><span class='read-less' title='Click to Show Less'>" + readLessTxt + "</span>";
                $(this).html(strtoadd);
            }
        });

        //Read More and Read Less Click Event binding
        $(document).on("click", ".read-more,.read-less", function () {
            $(this).closest(".add-read-more").toggleClass("show-less-content show-more-content");
        });
    }

    AddReadMore();
});

function myFunction() {
    var dots = document.getElementById("dots");
    var moreText = document.getElementById("more");
    var btnText = document.getElementById("myBtn");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}